'use client';

import React, { ReactNode, Suspense, useEffect } from 'react';
import Toaster from '@/components/Toaster';
import useCartState from '@/stores/cart-state';
import analytics from '@/lib/analytics';

type Props = {
  children?: ReactNode;
};

const AppClientRoot: React.FC<Props> = ({ children }) => {
  useEffect(() => {
    useCartState.persist.rehydrate();
  }, []);

  useEffect(() => {
    analytics.init();
  }, []);

  return (
    <>
      <Suspense>
        <Toaster />
      </Suspense>
      {children ?? null}
    </>
  );
};

export default AppClientRoot;
